import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageHeader from "../component/layout/pageheader";
import MemberShip from "../component/section/memberShip";
import { toastMaker, validateEmail } from "../utils/utility";
import { passwordStrength } from "check-password-strength";
import BannerSection from "../component/section/banner";
import matrimonyInstance from "../utils/axios";
import { CREATE_USER } from "../API_LIST";
import Datetime from "react-datetime";
import moment from "moment";
import LoaderComponent from "../component/loader/LoaderComponent";
import "react-datetime/css/react-datetime.css";

const Register = () => {
	const navigate = useNavigate();

	const [userData, setUserData] = useState({
		first_name: "",
		last_name: "",
		gender: "",
		phone_number: "",
		address_1: "",
		address_2: "",
		email: "",
		password: "",
		gothram: "",
		shaka: "",
	});

	const [confirmPassword, setIsConfirmPassword] = useState("");
	const [isTerms, setIsTerms] = useState(false);
	const [isRequired, setIsRequired] = useState(false);
	const [loading, setLoading] = useState(false);

	const [isVisiblePassword, setIsVisiblePassword] = useState(false);
	const [isConfirmVisible, setIsConfirmVisible] = useState(false);
	const [isRegisterPage, setIsRegisterPage] = useState(true);

	const handleChange = (e, date) => {
		const { name, value, pattern } = e.target;
		let formattedValue = value;

		if (pattern && value) {
			let regex = new RegExp(pattern);
			let result = regex.test(value);
			if (!result) return;
		}
		if (e == "profile_date_of_birth") {
			setUserData((prev) => {
				return { ...prev, [e]: date };
			});
		} else if (
			e.target.name === "first_name" ||
			e.target.name === "last_name"
		) {
			if (/^[a-zA-Z ]*$/.test(e.target.value)) {
				setUserData((prev) => {
					return { ...prev, [e.target.name]: e.target.value };
				});
			}
		} else {
			setUserData((prev) => {
				return { ...prev, [e.target.name]: e.target.value };
			});
		}
	};

	const createUser = async (e) => {
		e.preventDefault();
		setIsRequired(true);

		if (
			userData.first_name == "" ||
			userData.last_name == "" ||
			userData.gender == "" ||
			userData.phone_number == "" ||
			userData.address_1 == "" ||
			userData.address_2 == "" ||
			userData.gothram == "" ||
			userData.email == "" ||
			userData.password == "" ||
			confirmPassword == ""
		) {
			return toastMaker("Missing required fields", "error");
		}

		if (!validateEmail(userData?.email)) {
			return toastMaker("Enter a valid email", "error");
		}
		if (userData?.password.length < 6) {
			return toastMaker("Password must be at least 6 characters", "error");
		}
		if (userData?.password !== confirmPassword) {
			return toastMaker(
				"Password and Confirm Password does not match",
				"error",
			);
		}
		if (!isTerms) {
			return toastMaker("Please Agree to our terms and conditions.", "error");
		}
		setLoading(true);
		let data = userData;
		matrimonyInstance
			.post(CREATE_USER, data)
			.then((response) => {
				setLoading(false);
				toastMaker("Registration Successful", "success");
				navigate("/login");
			})
			.catch((error) => {
				setLoading(false);
				console.log("error");
				toastMaker(error, "Error");
			});
	};

	const minDate = moment().format("YYYY-MM-DD");

	return (
		<div className="container">
			{loading && <LoaderComponent />}
			<div className="login-section padding-tb">
				<div className="row">
					<div className="col-12 col-lg-8 col-sm-12">
						<div className="account-container">
							<h3 className="account-title">
								{isRegisterPage
									? "Create Your Matrimony Account"
									: "Terms & Conditions"}
							</h3>
							<div className="account-wrapper">
								{isRegisterPage ? (
									<React.Fragment>
										<div className="account-form">
											<div className="row row-gap-3 userclick-container mx-0">
												<p className="mb-15">
													Fill out the form to get started.
												</p>
												<form onSubmit={createUser}>
													<div className="row mb-20 mx-0">
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span
																		className={
																			isRequired &&
																			userData?.first_name?.length === 0 &&
																			"color-red"
																		}
																	>
																		First Name *
																	</span>
																</div>
																<input
																	type="text"
																	id="item01"
																	name="first_name"
																	value={userData.first_name}
																	onChange={handleChange}
																	required={true}
																	pattern="^[a-zA-Z ]+$"
																/>
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span
																		className={
																			isRequired &&
																			userData?.last_name?.length === 0 &&
																			"color-red"
																		}
																	>
																		Last Name *
																	</span>
																</div>
																<input
																	type="text"
																	name="last_name"
																	pattern="^[a-zA-Z ]+$"
																	value={userData.last_name}
																	onChange={handleChange}
																/>
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span
																		className={
																			isRequired &&
																			userData?.gender?.length === 0 &&
																			"color-red"
																		}
																	>
																		Gender *
																	</span>
																</div>
																<select
																	className="form-select"
																	name="gender"
																	value={userData.gender}
																	onChange={handleChange}
																>
																	<option value="" disabled>
																		Select
																	</option>
																	<option value="male">Male</option>
																	<option value="female">Female</option>
																</select>
															</div>
														</div>
														{/* Commented the DOB input field after requirement change */}
														{/* <div className="col-lg-6 col-sm-10 col-12 px-3">
                            <div className="form-group">
                              <div className="input-title">
                                <span className={isRequired && !userData?.date_of_birth ? "color-red" : ""}>
                                  Date Of Birth *
                                </span>
                              </div>
                              <Datetime
                                value={userData?.date_of_birth ? moment(userData.date_of_birth).format("YYYY-MM-DD") : ""}
                                inputProps={{
                                  name: "date_of_birth",
                                  type: "date", 
                                }}
                                dateFormat="MM-DD-YYYY"
                                timeFormat={false}
                                isValidDate={(current) =>
                                  current.isSameOrBefore(moment(), "day")
                                } // Disables future dates
                                onChange={(date) =>
                                  handleChange(
                                    "date_of_birth",
                                    moment(date).format("YYYY-MM-DD")
                                  )
                                }
                              />
                            </div>
                          </div> */}
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span
																		className={
																			isRequired &&
																			userData?.email?.length === 0 &&
																			"color-red"
																		}
																	>
																		Email Address *
																	</span>
																</div>
																<input
																	id="item06"
																	type="email"
																	name="email"
																	value={userData.email}
																	onChange={handleChange}
																/>
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span
																		className={
																			isRequired &&
																			userData?.phone_number?.length === 0 &&
																			"color-red"
																		}
																	>
																		Phone Number *
																	</span>
																</div>
																<input
																	id="item06"
																	type="tel"
																	name="phone_number"
																	pattern="^\+?\d{1,15}$"
																	value={userData.phone_number}
																	maxLength="15"
																	onChange={handleChange}
																/>
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span
																		className={
																			isRequired &&
																			userData?.gothram?.length === 0 &&
																			"color-red"
																		}
																	>
																		Gotram *
																	</span>
																</div>
																<input
																	id="item06"
																	type="text"
																	name="gothram"
																	value={userData.gothram}
																	pattern="^[a-zA-Z ]+$"
																	onChange={(e) => {
																		handleChange(e);
																	}}
																/>
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span
																		className={
																			isRequired &&
																			userData?.address_1?.length === 0 &&
																			"color-red"
																		}
																	>
																		Address Line 1 *
																	</span>
																</div>
																<input
																	id="item06"
																	type="text"
																	name="address_1"
																	value={userData.address_1}
																	onChange={handleChange}
																/>
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span
																		className={
																			isRequired &&
																			userData?.address_2?.length === 0 &&
																			"color-red"
																		}
																	>
																		Address Line 2 *
																	</span>
																</div>
																<input
																	id="item06"
																	type="text"
																	name="address_2"
																	value={userData.address_2}
																	onChange={handleChange}
																/>
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group mb-15">
																<div className="input-title">
																	<span
																		className={
																			isRequired &&
																			userData?.password?.length === 0 &&
																			"color-red"
																		}
																	>
																		Password *
																	</span>
																</div>
																<div className="input-field position-relative">
																	<input
																		id="item07"
																		className="with-icon"
																		type={
																			isVisiblePassword ? "text" : "password"
																		}
																		name="password"
																		minLength={6}
																		maxLength={20}
																		value={userData.password}
																		onChange={handleChange}
																	/>
																	<div
																		className="password-visible-icon"
																		onClick={() =>
																			setIsVisiblePassword(!isVisiblePassword)
																		}
																	>
																		{isVisiblePassword ? (
																			<svg
																				xmlns="http://www.w3.org/2000/svg"
																				fill="none"
																				viewBox="0 0 24 24"
																				strokeWidth={1.5}
																				stroke="currentColor"
																				className="size-6"
																			>
																				<path
																					strokeLinecap="round"
																					strokeLinejoin="round"
																					d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
																				/>
																				<path
																					strokeLinecap="round"
																					strokeLinejoin="round"
																					d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
																				/>
																			</svg>
																		) : (
																			<svg
																				xmlns="http://www.w3.org/2000/svg"
																				fill="none"
																				viewBox="0 0 24 24"
																				strokeWidth={1.5}
																				stroke="currentColor"
																				className="size-6"
																			>
																				<path
																					strokeLinecap="round"
																					strokeLinejoin="round"
																					d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
																				/>
																			</svg>
																		)}
																	</div>
																</div>
																<p className="mt-15">
																	{userData?.password?.length > 0 &&
																		`Password is ${passwordStrength(
																			userData.password,
																		)?.value?.toLocaleLowerCase()}`}
																</p>
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group mb-15">
																<div className="input-title">
																	<span
																		className={
																			isRequired &&
																			confirmPassword?.length === 0 &&
																			"color-red"
																		}
																	>
																		Confirm Password *
																	</span>
																</div>
																<div className="input-field position-relative">
																	<input
																		type={
																			isConfirmVisible ? "text" : "password"
																		}
																		className="with-icon"
																		name="confirmPassword"
																		value={confirmPassword}
																		minLength={6}
																		maxLength={20}
																		onChange={(e) =>
																			setIsConfirmPassword(e.target.value)
																		}
																	/>
																	<div
																		className="password-visible-icon"
																		onClick={() =>
																			setIsConfirmVisible(!isConfirmVisible)
																		}
																	>
																		{isConfirmVisible ? (
																			<svg
																				xmlns="http://www.w3.org/2000/svg"
																				fill="none"
																				viewBox="0 0 24 24"
																				strokeWidth={1.5}
																				stroke="currentColor"
																				className="size-6"
																			>
																				<path
																					strokeLinecap="round"
																					strokeLinejoin="round"
																					d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
																				/>
																				<path
																					strokeLinecap="round"
																					strokeLinejoin="round"
																					d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
																				/>
																			</svg>
																		) : (
																			<svg
																				xmlns="http://www.w3.org/2000/svg"
																				fill="none"
																				viewBox="0 0 24 24"
																				strokeWidth={1.5}
																				stroke="currentColor"
																				className="size-6"
																			>
																				<path
																					strokeLinecap="round"
																					strokeLinejoin="round"
																					d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
																				/>
																			</svg>
																		)}
																	</div>
																</div>
															</div>
														</div>
														<div className="confirmation-button mt-10">
															<input
																type="checkbox"
																name=""
																id="terms-condition"
																checked={isTerms}
																onChange={() => setIsTerms(!isTerms)}
															/>
															<label
																className="content cursor-pointer"
																htmlFor="terms-condition"
															>
																By signing up you agree to our{" "}
																<a
																	className="login-account"
																	onClick={() => setIsRegisterPage(false)}
																>
																	terms and conditions.
																</a>
															</label>
														</div>
														<button
															className="button login-btn create-btn text-white"
															onClick={createUser}
														>
															CREATE ACCOUNT
														</button>
													</div>
												</form>
											</div>
											<div className="account-bottom text-center">
												<p className="d-block cate pt-10">
													<p>
														If you are an existing BAT member, please log in
														using your BAT account
													</p>
												</p>
												<p className="mt-10">
													<Link to="/login" className="login-account">
														Login to your Account
													</Link>
												</p>
											</div>
										</div>
									</React.Fragment>
								) : (
									<div className="content">
										<ul className="list-style number mb-20">
											<li>
												The minimum age for registration with BAT MATRIMONY as a
												member is 18 years.
											</li>
											<li>
												The information provided by the member/member’s
												parent/legal guardian should be legitimate and true. The
												member/member’s parent/legal guardian would be liable
												and solely responsible for any consequences arising out
												of inaccurate or false information. BAT Matrimony will
												not be responsible for any false or inaccurate
												information provided by member/member’s parent/ legal
												guardian.
											</li>
											<li>
												BAT Matrimony reserves the right to refuse a member’s
												application for registration and also cancel a member’s
												registration if the information provided is false or
												misleading.
											</li>
											<li>
												Members should upload their most recent photographs (not
												older than three months). BAT Matrimony reserves the
												right to use these pictures on its website.
											</li>
											<li>
												BAT Matrimony will not undertake or involve in any
												financial negotiation or personal items such as gold,
												properties, etc on behalf of members.
											</li>
											<li>
												Membership registration fee is $150 USD for annual
												subscription. If the membership is not active, BAT
												Creations will not provide any of its services.
											</li>
											<li>
												Membership registration fees are non-refundable and
												non-transferable.
											</li>
											<li>
												The profiles of members are confidential and would be
												shared only after obtaining prior permission from the
												respective members/member’s parents/legal guardian.
											</li>
											<li>
												Members are required to update BAT Matrimony of any
												changes to their marital status. If a member marries
												subsequent to registering with BAT Matrimony, his/her
												membership would be cancelled.
											</li>
											<li>
												All content on (WEBSITE BAT MATRIMONY) website is the
												property of BAT Matrimony or its affiliates and is
												protected by copyright laws.
											</li>
											<li>
												BAT Matrimony reserves the right to change the existing
												terms and conditions without prior notice.
											</li>
											<li>
												BAT is not responsible for any legal allegations rising
												between the registered members in any way.
											</li>
										</ul>
										<div className="back-to-sugnup d-flex justify-content-center">
											<button
												type="button"
												onClick={() => setIsRegisterPage(true)}
												className="button login-btn text-white"
											>
												BACK TO REGISTER
											</button>
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
					<div className="col-12 col-lg-4 col-sm-12">
						{/* <MemberShip /> */}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Register;
